<template>
    <div
        v-if="tableTabKeyActive !== ''"
        class="table-tabs"
    >
        <button
            v-for="(tabKey, indexTab) in Object.keys(tableTabs)"
            :key="indexTab"
            class="table-tabs__tab-item"
            :class="{'table-tabs__tab-item_active': tabKey === tableTabKeyActive}"
            @click="onClickTab(tabKey)"
        >
            {{tableTabs[tabKey].title || ''}}
        </button>
    </div>
</template>

<script>
export default {
    name: 'TableTabs',
    /**
     * Входные данные комопнента
     * @property {object} tableTabs - таблицы разбитые по табам
     * @property {string} tableTabKeyActive - ключ активного таба
     */
    props: {
        tableTabs: {
            type: Object,
            default: () => ({})
        },
        tableTabKeyActive: {
            type: String,
            default: ''
        }
    },
    methods: {
        /**
         * событие клика по табу
         * @param {string} tabKey - ключ таба
         */
        onClickTab(tabKey) {
            this.$emit('onClickTab', tabKey);
        }
    }
}
</script>

<style lang="scss" scoped>
    .table-tabs {
        display: flex;
        margin-bottom: 20px;
    }
    .table-tabs__tab-item {
        margin-right: 5px;
        border: none;
        background: none;
        cursor: pointer;
        outline: none;
        color: #696969;
    }
    .table-tabs__tab-item_active {
        color: #258df5;
    }
</style>